import { snakeCaseToTitleCase } from "common/utils/strings";
import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_185: DocMigration = {
  maxSchemaVersion: "0.0.185",
  description: "Move floorPlateThickness from level to level floor settings",

  apply(json: any) {
    const { levels } = json;

    for (const levelId in levels) {
      const level = levels[levelId];
      const { floorPlateThickness } = level;
      delete level.floorPlateThickness;

      // add new floor settings to the level settings
      const floorSettingsId = uid();
      json.settings = {
        ...json.settings,
        [floorSettingsId]: {
          name: snakeCaseToTitleCase("FLOOR_SETTINGS"),
          entityType: "SETTINGS",
          id: floorSettingsId,
          type: "FLOOR_SETTINGS",
          floorPlateThickness,
          parentId: levelId,
          sortIndex: 0,
        },
      };
    }
    return json;
  },
};

export default migration_0_0_185;
